import React from "react";

import { CreditCard, Phone, Mail, MapPin } from "lucide-react";

import "./Footer.css";

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-container">
        {/* FOOTER MAIN */}

        <div className="footer-main">
          {/* LOGO */}

          <a href="/" className="footer-logo">
            <div className="footer-logo-icon">
              <CreditCard size={34} strokeWidth={2.8} />
            </div>

            <div className="footer-logo-text">
              <strong>RÚT THẺ NHANH</strong>

              <span>Nhanh chóng - An toàn - Uy tín</span>
            </div>
          </a>

          {/* CONTACT INFORMATION */}

          <div className="footer-info">
            {/* HOTLINE */}

            <a href="tel:0941342598" className="footer-item">
              <Phone className="footer-item-icon" />

              <div className="footer-item-text">
                <strong>Hỗ trợ 24/7</strong>

                <span>0941 342 598</span>
              </div>
            </a>

            {/* EMAIL */}

            <a
              href="mailto:hotro@ruttienthetindunghcm.online"
              className="footer-item"
            >
              <Mail className="footer-item-icon" />

              <div className="footer-item-text">
                <strong>Email</strong>

                <span>hotro@ruttienthetindunghcm.online</span>
              </div>
            </a>

            {/* LOCATION */}

            <div className="footer-item">
              <MapPin className="footer-item-icon" />

              <div className="footer-item-text">
                <strong>Phục vụ khu vực</strong>

                <span>TPHCM</span>
              </div>
            </div>
          </div>
        </div>

        {/* FOOTER BOTTOM */}

        <div className="footer-bottom">
          <p>
            © {new Date().getFullYear()} Rút Thẻ Nhanh Tphcm. All rights
            reserved.
          </p>

          <div className="footer-links">
            <a href="/chinh-sach-bao-mat">Chính sách bảo mật</a>

            <span className="footer-divider">|</span>

            <a href="/dieu-khoan-su-dung">Điều khoản sử dụng</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
